<app-header></app-header>
<header class="slidermain menu-page text-white login-page">
    <img src="assets/img/productb1.jpg" alt="news" class="w-100">
  <div class="container-fluid">
     <div class="mask-content-v-center text-left log-card">

        <div class="col-md-4 mx-auto"> 
         
                <div class="login-box">
                    <div class="card-body login-card">
                        <h5 class="card-title">{{ 'login.resetpassword' | translate }}</h5>
                          <div class="form-signin">
                            <div class="form-group">
                                <input type="password"  name="new_pass" class="form-control" placeholder="{{ 'login.enter_newpass' | translate }}" required #newpass>
                            </div>

                            <div class="form-group">
                                <input type="password" name="cnf_pass" class="form-control" placeholder="{{ 'login.confirm_pass' | translate }}" required #cnfpass>
                            </div>
                            <span  class="errcls" *ngIf="errMsg !='' && showLang == 'en' ">{{errMsg}}</span>
                            <span  class="errcls" *ngIf="errMsg_ar !='' && showLang == 'ar' ">{{errMsg_ar}}</span>

                            <p  class="text-success" *ngIf="sucsMsg !='' && showLang == 'en' ">Password updated successfully. <a href='login'>Click here to login</a></p>
                            <p  class="text-success" *ngIf="sucsMsg !='' && showLang == 'ar' ">تم تحديث كلمة السر بنجاح <a href='login'>انقر هنا لتسجيل الدخول</a></p>
                        <button (click)="reResetPass(newpass.value, cnfpass.value)"  class="btn btn-lg btn-primary orderonline"><i class="fas fa-sign-in-alt"></i> 
                            {{ 'login.submit' | translate }}
                            <span *ngIf="isLoading">
                                <i class="fas fa-circle-notch fa-spin"></i>
                            </span>
                        </button>
                        </div>
                        
                    </div>
                </div>
            
 </div>
</div>
</div>
</header>
